import React, { useState, useMemo } from "react";
import BrandVoiceModal from "../modals/brandVoiceModal";
import {
  Button,
  Paper,
  Stack,
  Typography,
  IconButton,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Menu,
  Divider,
  useTheme,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useDispatch } from "react-redux";
import { triggerDeleteBrandVoice } from "../../../store/slices/brandVoice";

const BrandVoice = ({
  brandVoiceData,
  companyId,
  classes,
  selectedBrandVoiceContainer,
  setSelectedBrandVoiceContainer,
  selectedLocation,
}) => {
  const theme = useTheme();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedBrandVoiceId, setSelectedBrandVoiceId] = useState(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const dispatch = useDispatch();

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditData(null);
  };

  const handleMoreVertClick = (event, brandVoiceId) => {
    setAnchorEl(event.currentTarget);
    setSelectedBrandVoiceId(brandVoiceId);
  };

  const handleMoreVertClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    if (selectedBrandVoiceId) {
      const selectedBrandVoice = brandVoiceData.find(
        (brandVoice) => brandVoice.brandVoiceId === selectedBrandVoiceId
      );
      if (selectedBrandVoice) {
        setEditData(selectedBrandVoice);
        setIsModalOpen(true);
      }
    }
    setSelectedBrandVoiceId(null);
    handleMoreVertClose();
  };

  const handleDeleteClick = () => {
    setIsDeleteDialogOpen(true);
    handleMoreVertClose();
  };

  const handleDeleteCancel = () => {
    setIsDeleteDialogOpen(false);
    setSelectedBrandVoiceId(null);
  };

  const handleDeleteConfirm = () => {
    if (selectedBrandVoiceId) {
      dispatch(triggerDeleteBrandVoice(selectedBrandVoiceId, companyId));
    }
    setIsDeleteDialogOpen(false);
    setSelectedBrandVoiceId(null);
  };

  const memoizedBrandVoiceData = useMemo(() => {
    let clonedData = [...brandVoiceData];

    if (selectedLocation && selectedLocation !== "all") {
      clonedData = clonedData.filter(
        (item) => item.locationId === selectedLocation
      );
    }

    clonedData.sort((a, b) => {
      const dateA = new Date(a.createdOn);
      const dateB = new Date(b.createdOn);
      return dateB - dateA;
    });
    return clonedData;
  }, [brandVoiceData, selectedLocation]);

  const handleBrandVoiceContainerClick = (brandVoiceId, event) => {
    const selectedBrandVoice = brandVoiceData.find(
      (brandVoice) => brandVoice.brandVoiceId === brandVoiceId
    );

    if (selectedBrandVoice) {
      if (event.target.tagName !== "svg") {
        if (
          selectedBrandVoiceContainer &&
          selectedBrandVoiceContainer.brandVoiceId === brandVoiceId
        ) {
          setSelectedBrandVoiceContainer(null);
        } else {
          setSelectedBrandVoiceContainer(selectedBrandVoice);
        }
      }
    }
  };

  return (
    <>
      <Stack
        direction="row"
        justifyContent={"flex-end"}
        mt={2}
    
      >
        <span>
          <Button
            variant="outlined"
            color="primary"
            sx={{ textTransform: "none" }}
            onClick={openModal}
          >
            Add Voice
          </Button>
        </span>
      </Stack>
<div className={classes.reviewContainer2} style={{paddingBottom:0}}>
      <div >
        {memoizedBrandVoiceData?.map((brandVoice) => (
          <Paper
            key={brandVoice.brandVoiceId}
            className={classes.reviewBox}
            onClick={(event) =>
              handleBrandVoiceContainerClick(brandVoice.brandVoiceId, event)
            }
            sx={{
              cursor: "pointer",
              background:
                brandVoice.brandVoiceId ===
                selectedBrandVoiceContainer?.brandVoiceId
                  ? (theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.1)' : "#D9EDFD")
                  : "",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "-11px",
              }}
            >
              <IconButton
                aria-label="More"
                aria-controls="brand-voice-menu"
                aria-haspopup="true"
                onClick={(event) =>
                  handleMoreVertClick(event, brandVoice.brandVoiceId)
                }
                size="small"
              >
                <MoreVertIcon />
              </IconButton>
            </div>
            <div className={classes.reviewHeader}>
              <Typography variant="subtitle2" sx={{ alignSelf: "flex-start" }}>
                {brandVoice.name}
              </Typography>
              <Typography variant="body2" sx={{ alignSelf: "flex-end" }}>
                {new Date(brandVoice.createdOn).toLocaleDateString()}
              </Typography>
            </div>
            <Typography
              className={classes.reviewText}
              variant="body1"
              dangerouslySetInnerHTML={{
                __html: brandVoice?.description?.replace(/\n/g, "<br/>"),
              }}
            />
          </Paper>
        ))}
      </div>
      </div>
      {isModalOpen && (
        <BrandVoiceModal
          open={isModalOpen}
          onClose={closeModal}
          companyId={companyId}
        />
      )}
      {isModalOpen && editData && (
        <BrandVoiceModal
          open={isModalOpen}
          onClose={closeModal}
          companyId={companyId}
          data={editData}
        />
      )}
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleMoreVertClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleEdit}>Edit</MenuItem>
        <MenuItem onClick={handleDeleteClick}>Delete</MenuItem>
      </Menu>
      <Dialog
        open={isDeleteDialogOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
      >
        <DialogTitle id="delete-dialog-title">Confirm Delete</DialogTitle>
        <Divider />
        <DialogContent>
          Are you sure you want to delete this brand voice?
        </DialogContent>
        <Divider />
        <DialogActions
          sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}
        >
          <Button
            onClick={handleDeleteConfirm}
            size="small"
            variant="contained"
            color="error"
          >
            Delete
          </Button>
          <Button
            variant="outlined"
            size="small"
            color="primary"
            onClick={handleDeleteCancel}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BrandVoice;
